<template lang="html">
  <footer id="footer" class="text-white pt-5 pb-4">
    <div class="container">
      <div class="row">
        <!-- Marca / descripción -->
        <div class="col-lg-4 mb-4">
          <div class="d-flex align-items-center mb-3">
            <span class="home2-footer-logo-part-1">ECO</span>
            <span class="home2-footer-logo-part-2">México</span>
          </div>
          <p class="text-light-50 mb-4">
            Líderes en tecnología de drones profesionales en México. Distribuidor oficial DJI con más de 15 años de
            experiencia.
          </p>

          <div class="d-flex flex-wrap">
            <a
              v-for="(social, index) in socialLinks"
              :key="index"
              :href="social.href"
              class="home2-footer-social-btn"
              :aria-label="social.label"
              target="_blank"
              rel="noopener"
            >
              <i :class="social.iconClass"></i>
            </a>
          </div>
        </div>

        <!-- Listas de enlaces -->
        <div class="col-6 col-md-3 col-lg-2 mb-4" v-for="(links, sectionKey) in footerLinks" :key="sectionKey">
          <h4 class="home2-footer-section-title">
            {{ sectionTitles[sectionKey] }}
          </h4>
          <ul class="list-unstyled mb-0">
            <li v-for="(link, index) in links" :key="index" class="mb-2">
              <!-- Enlaces internos que existen en tu router -->
              <router-link
                v-if="sectionKey === 'empresa' && link === 'Empresa'"
                to="/empresa"
                class="home2-footer-link"
              >
                {{ link }}
              </router-link>

              <router-link
                v-else-if="sectionKey === 'soporte' && link === 'Blog'"
                to="/blog"
                class="home2-footer-link"
              >
                {{ link }}
              </router-link>

              <router-link
                v-else-if="sectionKey === 'soporte' && link === 'Contacto'"
                to="/contacto"
                class="home2-footer-link"
              >
                {{ link }}
              </router-link>

              <!-- Enlaces de ejemplo / por definir -->
              <a v-else href="#" class="home2-footer-link">
                {{ link }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom -->
      <div
        class="border-top border-secondary mt-4 pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center text-center"
      >
        <p class="mb-2 mb-md-0 small text-light-50">
          © {{ currentYear }} EcoMéxico. Todos los derechos reservados.
        </p>
        <div class="d-flex flex-wrap justify-content-center justify-content-md-end">
          <router-link
            to="/aviso-de-privacidad"
            class="home2-footer-link small mr-3"
          >
            Aviso de Privacidad
          </router-link>
          <a href="#" class="home2-footer-link small mr-3">
            Términos de Servicio
          </a>
          <a href="#" class="home2-footer-link small">
            Cookies
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
      footerLinks: {
        productos: ['DJI Matrice 4E', 'DJI Matrice 4T', 'DJI Matrice 4M', 'Accesorios', 'Repuestos'],
        servicios: ['Fotografía Aérea', 'Mapeo y Topografía', 'Inspección Industrial', 'Capacitación', 'Soporte Técnico'],
        empresa: ['Empresa', 'Nuestro Equipo', 'Certificaciones', 'Casos de Éxito', 'Carreras'],
        soporte: ['Centro de Ayuda', 'Documentación', 'Garantías', 'Contacto', 'Blog'],
      },
      sectionTitles: {
        productos: 'Productos',
        servicios: 'Servicios',
        empresa: 'Empresa',
        soporte: 'Soporte',
      },
      socialLinks: [
        { iconClass: 'fa-brands fa-facebook-f', href: '#', label: 'Facebook' },
        { iconClass: 'fa-brands fa-instagram', href: '#', label: 'Instagram' },
        { iconClass: 'fa-brands fa-linkedin-in', href: '#', label: 'LinkedIn' },
        { iconClass: 'fa-brands fa-youtube', href: '#', label: 'YouTube' },
      ],
    };
  },
};
</script>